import Backdrop from '@mui/material/Backdrop';
import MuiDialog, { dialogClasses } from '@mui/material/Dialog';

import styled from 'shared/utils/styled';

type DialogAccessories = Partial<{
  fullHeight: boolean;
}>;

export const StyledDialog = styled(MuiDialog, {
  shouldForwardProp: (prop) => prop !== 'fullHeight',
})<DialogAccessories>(({ theme, fullHeight = false }) => ({
  [`& .${dialogClasses.paper}`]: {
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
      margin: '16px 8px',
      maxHeight: 'calc(100% - 32px)',
      width: 'calc(100% - 16px)',
    },
    ...(fullHeight && {
      height: '100%',
    }),
  },
}));

export const StyledBackdrop = styled(Backdrop)(() => ({
  background: 'rgba(34, 64, 96, .64)',
}));
